import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
}
export function AccordionItem({
  title,
  children,
  isOpen: defaultOpen = false
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-zinc-800 rounded-lg overflow-hidden bg-zinc-900/50 backdrop-blur-sm mb-3" data-id="element-183">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-zinc-800/50 transition-colors" data-id="element-184">
        <span className="font-display text-lg md:text-xl text-zinc-100 pr-4" data-id="element-185">
          {title}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-amber-400" data-id="element-186">
          <ChevronDown className="w-6 h-6" data-id="element-187" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-188">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-189">
            <div className="px-6 pb-5 pt-2 text-zinc-400 space-y-3" data-id="element-190">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}